import * as React from 'react';

import { FarIcons } from '@playbooks/icons';
import {
	type InputGroupProps,
	InputGroup,
	InputGroupAddon,
	InputGroupButton,
	InputGroupInput,
} from '@playbooks/ui/components/input-group';
import { StructuralIcon } from '@playbooks/ui/components/structural-icon';
import { cn } from '@playbooks/ui/lib/utils';

type SearchFieldProps = Omit<React.ComponentProps<typeof InputGroupInput>, 'size' | 'type'> & {
	size?: InputGroupProps['size'];
	onClear?: () => void;
	isLoading?: boolean;
	resultCount?: number;
};
function SearchField({ className = '', size, value, onClear, isLoading, resultCount, ...props }: SearchFieldProps) {
	const hasValue = typeof value === 'string' ? value.length > 0 : Boolean(value);
	return (
		<InputGroup size={size} className={className}>
			<InputGroupAddon isLoading={isLoading}>
				<StructuralIcon icon={FarIcons.farMagnifyingGlass} />
			</InputGroupAddon>
			<InputGroupInput
				type='search'
				value={value}
				{...props}
				className='[&::-webkit-search-cancel-button]:appearance-none'
			/>
			{resultCount !== undefined || (hasValue && onClear) ? (
				<InputGroupAddon align='inline-end'>
					{resultCount !== undefined ? (
						<span className='whitespace-nowrap text-xs text-foreground-subtle'>
							{resultCount} {resultCount === 1 ? 'result' : 'results'}
						</span>
					) : null}
					{hasValue && onClear ? (
						<InputGroupButton aria-label='Clear search' onClick={onClear}>
							<StructuralIcon icon={FarIcons.farXmark} />
						</InputGroupButton>
					) : null}
				</InputGroupAddon>
			) : null}
		</InputGroup>
	);
}
function FilterBar({ className = '', ...props }: React.ComponentProps<'div'>) {
	// Theme
	const rootClassName = cn('flex-start flex-wrap gap-2', className);

	// Render
	return <div {...props} className={rootClassName} />;
}
export { FilterBar, SearchField };
